import { HStack, Heading, Spacer, Stack, StackProps } from "@chakra-ui/react";
import * as React from "react";

export interface PageHeaderProps extends StackProps {
  children?: React.ReactNode;
  title: string;
  subtitle?: string;
}

export default function PageHeader(props: PageHeaderProps) {
  const { children, title, subtitle, ...rootProps } = props;
  return (
    <HStack {...rootProps}>
      <Stack gap="1">
        <Heading size="2xl" fontWeight="semibold">
          {title}
        </Heading>
        {subtitle && (
          <Heading color="fg.muted" size="sm" fontWeight="normal">
            {subtitle}
          </Heading>
        )}
      </Stack>
      <Spacer />
      {children}
    </HStack>
  );
}
